// SubmitButtonControlView

import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import template from 'common-visuals/control-submit-button.ejs';
import constants        from "Constants";

//=====================================================================
//
// An instance of this view represents a submit button control
//
// Lou Mauget, November 2015
//
//=====================================================================
class SubmitButtonControlView extends BaseControlView  {

        initialize( opts ) {

            super.initialize( opts );

            this.template = template;

            this.tagName = 'div';
            
            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
            this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'SubmitButtonControlView';
        }


}

export default SubmitButtonControlView